let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iX8MT")).then(() => parcelRequire('hIvJW'));